import { Link, useLocation } from 'react-router-dom'
import { useState, useEffect, useRef } from 'react'
import { Button } from '@/components/ui/button'
import { Sheet, SheetContent } from '@/components/ui/sheet'
import { useAuthStore } from '@/lib/stores/auth'
import { Menu, X, ChevronDown, LogIn } from 'lucide-react'

const SOCIAL_LINKS = [
  { name: 'YouTube', href: 'https://www.youtube.com/c/pastordavidogbueli', label: 'YouTube' },
  { name: 'Facebook', href: 'https://web.facebook.com/pastordavidogbueli', label: 'Facebook' },
  { name: 'LinkedIn', href: 'https://www.linkedin.com/in/drdavidogbueli/', label: 'LinkedIn' },
  { name: 'Twitter', href: 'https://www.twitter.com/pstdavidogbueli', label: 'Twitter / X' },
  { name: 'Instagram', href: 'https://www.instagram.com/pastordavidogbueli', label: 'Instagram' },
  { name: 'Telegram', href: 'http://t.me/dominioncityglobal', label: 'Telegram' },
  { name: 'TikTok', href: 'https://www.tiktok.com/@pastordavidogbueli', label: 'TikTok' },
  { name: 'WhatsApp', href: 'https://api.whatsapp.com/send?phone=2348103526864', label: 'WhatsApp' },
]

const SOCIAL_ICONS: Record<string, React.ReactNode> = {
  YouTube: <svg className="h-4 w-4" viewBox="0 0 24 24" fill="currentColor"><path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg>,
  Facebook: <svg className="h-4 w-4" viewBox="0 0 24 24" fill="currentColor"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>,
  LinkedIn: <svg className="h-4 w-4" viewBox="0 0 24 24" fill="currentColor"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>,
  Twitter: <svg className="h-4 w-4" viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>,
  Instagram: <svg className="h-4 w-4" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.273 5.502v18.019C.273 21.309.681 21.323 3.947 21.323c3.251 0 3.679-.014 4.809-.072 4.358-.2 6.78-2.618 6.78-6.987V5.501C20.537 2.691 20.129 2.676 16.868 2.676 13.617 2.676 13.187 2.69 12 2.69zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z"/></svg>,
  Telegram: <svg className="h-4 w-4" viewBox="0 0 24 24" fill="currentColor"><path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.338 1.878-.338 1.954a.75.75 0 0 0 1.196.698l5.132-3.349a1.12 1.12 0 0 0 .381-.929l-.32-3.046c-.016-.17.043-.31.2-.37l4.823-2.142a1.05 1.05 0 0 0 .654-.947l.2-4.484a1.11 1.11 0 0 0-.99-1.207l-4.18-.002zm-2.022 3.96c-.168 0-.317.077-.441.229-.124.153-.204.356-.204.59 0 .23.08.454.24.59.159.137.31.23.465.232.156-.002.318-.095.443-.233.125-.137.207-.356.207-.59a.63.63 0 0 0-.207-.585c-.125-.135-.28-.228-.444-.23z"/></svg>,
  TikTok: <svg className="h-4 w-4" viewBox="0 0 24 24" fill="currentColor"><path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.37-4.81 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/></svg>,
  WhatsApp: <svg className="h-4 w-4" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.868-2.031-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z"/></svg>,
}

interface NavItem {
  label: string
  href?: string
  children?: Array<{
    label: string
    href: string
    description?: string
  }>
}

const navItems: NavItem[] = [
  {
    label: 'About Dr David',
    href: '/about',
  },
  {
    label: 'Ministries',
    href: '/ministry',
  },
  {
    label: 'Events',
    href: '/events',
  },
  {
    label: 'Broadcast',
    href: '/broadcast',
  },
  {
    label: 'Media Center',
    href: '/media',
  },
  {
    label: 'Give',
    href: '/give',
  },
  {
    label: 'Contact',
    href: '/contact',
  },
]

interface PublicHeaderProps {
  hasHeroSection?: boolean
}

export function PublicHeader({ hasHeroSection = true }: PublicHeaderProps) {
  const { isAuthenticated } = useAuthStore()
  const location = useLocation()
  const [isScrolled, setIsScrolled] = useState(false)
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
  const [openDropdown, setOpenDropdown] = useState<string | null>(null)
  const dropdownRef = useRef<HTMLDivElement>(null)

  // Check if we're on an auth page
  const isAuthPage = location.pathname.startsWith('/auth') || location.pathname.startsWith('/signin') || location.pathname.startsWith('/request-access')

  const isHomePage = location.pathname === '/'
  const shouldUseTransparentHeader = false
  const useDarkText = true

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const handleScroll = () => {
      const scrollOffset = window.scrollY;
      setIsScrolled(scrollOffset > 20);
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close mobile menu when route changes
  useEffect(() => {
    setIsMobileMenuOpen(false)
    setOpenDropdown(null)
  }, [location.pathname])

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setOpenDropdown(null)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  const getNavItemClass = (isMobile = false) => {
    if (useDarkText) {
      return isMobile
        ? 'text-gray-700 hover:text-primary hover:bg-primary/10'
        : 'text-muted-foreground hover:text-foreground hover:bg-accent'
    }
    return isMobile
      ? 'text-gray-700 hover:text-primary hover:bg-primary/10'
      : 'text-white/80 hover:text-white hover:bg-white/10'
  }

  const handleDropdownToggle = (label: string) => {
    setOpenDropdown(openDropdown === label ? null : label)
  }

  return (
    <>
      <header className={`sticky top-0 z-50 w-full transition-all duration-300 ease-in-out ${shouldUseTransparentHeader ? 'border-transparent bg-transparent' : 'bg-background'}`}>
        <div className={`mx-auto max-w-7xl px-4 flex h-16 items-center justify-between ${useDarkText ? '' : 'text-white'}`}>
          {/* Logo - 1x1 with text */}
          <Link to="/" className="flex items-center gap-3">
            <div className="relative h-10 w-10 flex-shrink-0">
              <img
                src="/logo.png"
                alt="Dominion Mandate logo"
                className="w-full h-full object-contain rounded-full"
              />
            </div>
            <span className={`font-bold text-lg max-[430px]:hidden ${isAuthPage ? 'hidden' : ''} ${useDarkText ? 'text-foreground' : 'text-white'}`}>Dominion Mandate</span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-1">
            {navItems.map((item) => (
              <div key={item.label} className="relative" ref={dropdownRef}>
                {item.children ? (
                  <div className="relative group">
                    <button
                      onClick={() => handleDropdownToggle(item.label)}
                      className={`px-4 py-2 text-sm font-medium transition-colors rounded-md flex items-center gap-1 ${getNavItemClass()}`}
                    >
                      {item.label}
                      <ChevronDown className={`h-4 w-4 transition-transform ${openDropdown === item.label ? 'rotate-180' : ''}`} />
                    </button>
                    {/* Dropdown menu */}
                    <div className={`absolute top-full left-0 mt-1 w-64 rounded-md border bg-background shadow-lg transition-all duration-200 ${openDropdown === item.label ? 'opacity-100 visible translate-y-0' : 'opacity-0 invisible -translate-y-2'}`}>
                      <div className="py-2">
                        {item.children.map((child) => (
                          <Link
                            key={child.href}
                            to={child.href}
                            className={`block px-4 py-2 text-sm transition-colors ${getNavItemClass(true)}`}
                            onClick={() => setOpenDropdown(null)}
                          >
                            <div className="font-medium">{child.label}</div>
                            {child.description && (
                              <div className="text-xs text-muted-foreground mt-0.5">{child.description}</div>
                            )}
                          </Link>
                        ))}
                      </div>
                    </div>
                  </div>
                ) : (
                  <Link
                    to={item.href!}
                    className={`px-4 py-2 text-sm font-medium transition-colors rounded-md ${getNavItemClass()}`}
                  >
                    {item.label}
                  </Link>
                )}
              </div>
            ))}
          </nav>

          {/* Mobile App Bar Actions */}
          <div className="lg:hidden ml-auto mr-2">
            {isAuthenticated ? (
              <Button asChild size="sm">
                <Link to="/dashboard">Dashboard</Link>
              </Button>
            ) : (
              <Button asChild size="sm" variant={useDarkText ? 'outline' : 'secondary'}>
                <Link to="/signin">
                  <LogIn className="h-4 w-4 mr-2" />
                  Sign In
                </Link>
              </Button>
            )}
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`lg:hidden flex items-center justify-center p-2 rounded-md ${useDarkText ? 'text-foreground' : 'text-white'}`}
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? (
              <X className="h-6 w-6" />
            ) : (
              <Menu className="h-6 w-6" />
            )}
          </button>

          {/* Desktop Actions */}
          <div className="hidden lg:flex items-center space-x-2">
            {isAuthenticated ? (
              <Button asChild variant={useDarkText ? 'default' : 'secondary'}>
                <Link to="/dashboard">Dashboard</Link>
              </Button>
            ) : (
              <Button variant={useDarkText ? 'outline' : 'ghost'} asChild className={useDarkText ? '' : 'bg-white/10 text-white hover:bg-white/20 border border-white/20 backdrop-blur-sm'}>
                <Link to="/signin">
                  <LogIn className="h-4 w-4 mr-2" />
                  Sign In
                </Link>
              </Button>
            )}
          </div>
        </div>
      </header>

      <Sheet open={isMobileMenuOpen} onOpenChange={setIsMobileMenuOpen}>
        <SheetContent
          side="right"
          className="lg:hidden w-80 max-w-[85vw] gap-0 p-0 bg-white"
        >
          <nav className="px-4 pt-4 pb-3 space-y-0.5 overflow-y-auto">
            {navItems.map((item) => (
              item.children ? (
                <div key={item.label} className="py-1">
                  <div className="px-4 py-2 text-sm font-semibold text-slate-700 uppercase tracking-wider">
                    {item.label}
                  </div>
                  {item.children.map((child) => (
                    <Link
                      key={child.href}
                      to={child.href}
                      className="block pl-8 pr-4 py-2.5 text-base font-medium text-slate-900 hover:text-primary hover:bg-primary/10 rounded-md transition-colors"
                      onClick={() => setIsMobileMenuOpen(false)}
                    >
                      {child.label}
                    </Link>
                  ))}
                </div>
              ) : (
                <Link
                  key={item.href}
                  to={item.href!}
                  className="block px-4 py-2.5 text-base font-medium text-slate-900 hover:text-primary hover:bg-primary/10 rounded-md transition-colors"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  {item.label}
                </Link>
              )
            ))}
          </nav>

          <div className="px-4 pb-6 pt-2 border-t border-border">
            <p className="text-xs text-muted-foreground uppercase tracking-wider mb-3">Follow Us</p>
            <div className="flex flex-wrap gap-2">
              {SOCIAL_LINKS.map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center h-8 w-8 rounded-full bg-secondary text-secondary-foreground hover:bg-primary hover:text-white transition-colors"
                  aria-label={link.label}
                >
                  {SOCIAL_ICONS[link.name]}
                </a>
              ))}
            </div>
          </div>
        </SheetContent>
      </Sheet>
    </>
  );
}
